import { render, staticRenderFns } from "./AboutJian.vue?vue&type=template&id=6cdcfc66&scoped=true&"
import script from "./AboutJian.vue?vue&type=script&lang=js&"
export * from "./AboutJian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcfc66",
  null
  
)

export default component.exports